export const heroContent = {
  tagline: "数字化解决方案专家",
  title: "用技术驱动",
  titleHighlight: "商业新未来",
  subtitle: "Tianyi 专注为企业提供从战略咨询到技术落地的全链路数字化服务，帮助品牌在数字时代脱颖而出。",
  ctaText: "探索我们的服务",
  ctaSecondary: "预约咨询",
};

export const services = [
  {
    id: "web-dev",
    icon: "ri-code-box-line",
    title: "高端网站开发",
    description: "从品牌官网到电商平台，我们打造兼具美学与性能的数字化门户，让你的品牌在线上焕发新生。",
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20web%20development%20workspace%20with%20laptop%20displaying%20clean%20website%20design%2C%20warm%20lighting%2C%20plant%20on%20desk%2C%20creative%20studio%20atmosphere%2C%20soft%20shadows%2C%20editorial%20style%20photography%20with%20neutral%20cream%20background&width=800&height=600&seq=service-web-01&orientation=landscape",
  },
  {
    id: "mobile-app",
    icon: "ri-smartphone-line",
    title: "移动应用开发",
    description: "iOS、Android、跨平台 — 我们开发原生体验的移动应用，让用户随时随地连接你的品牌。",
    image: "https://readdy.ai/api/search-image?query=Mobile%20app%20development%20concept%20with%20smartphone%20showing%20modern%20app%20interface%2C%20minimalist%20design%2C%20warm%20neutral%20background%2C%20soft%20lighting%2C%20clean%20aesthetic%2C%20tech%20lifestyle%20photography%20with%20cream%20tones&width=800&height=600&seq=service-mobile-02&orientation=landscape",
  },
  {
    id: "cloud",
    icon: "ri-cloud-line",
    title: "云计算解决方案",
    description: "弹性架构设计、云原生部署、自动化运维 — 让基础设施成为你的竞争力而非负担。",
    image: "https://readdy.ai/api/search-image?query=Cloud%20computing%20abstract%20visualization%20with%20geometric%20network%20nodes%2C%20warm%20toned%2C%20minimalist%20technology%20art%2C%20clean%20interconnected%20lines%2C%20soft%20gradient%20background%20in%20cream%20and%20warm%20beige%20tones&width=800&height=600&seq=service-cloud-03&orientation=landscape",
  },
  {
    id: "security",
    icon: "ri-shield-check-line",
    title: "网络安全服务",
    description: "渗透测试、安全审计、合规咨询 — 全方位的安全防护体系，守护你的数字资产安全。",
    image: "https://readdy.ai/api/search-image?query=Cybersecurity%20concept%20abstract%20shield%20with%20digital%20patterns%2C%20warm%20minimalist%20style%2C%20clean%20geometric%20design%2C%20soft%20lighting%2C%20cream%20and%20warm%20gray%20background%2C%20modern%20tech%20illustration&width=800&height=600&seq=service-security-04&orientation=landscape",
  },
];

export const projects = [
  {
    id: 1,
    title: "GreenLeaf 品牌官网",
    category: "品牌官网",
    description: "可持续生活方式品牌的全新数字化形象",
    color: "bg-[#f5e6d3]",
    image: "https://readdy.ai/api/search-image?query=Elegant%20ecommerce%20website%20design%20for%20sustainable%20lifestyle%20brand%2C%20warm%20earthy%20tones%2C%20clean%20minimalist%20layout%2C%20product%20display%20with%20natural%20aesthetic%2C%20soft%20cream%20background%2C%20modern%20web%20design%20showcase&width=600&height=800&seq=project-01&orientation=portrait",
  },
  {
    id: 2,
    title: "FitMotion 健身 App",
    category: "移动应用",
    description: "AI驱动的个性化健身训练平台",
    color: "bg-[#dce8d7]",
    image: "https://readdy.ai/api/search-image?query=Fitness%20mobile%20app%20interface%20design%20with%20clean%20modern%20layout%2C%20warm%20minimalist%20style%2C%20workout%20tracking%20display%2C%20soft%20sage%20green%20and%20cream%20tones%2C%20UI%20design%20showcase%20on%20phone%20mockup&width=600&height=800&seq=project-02&orientation=portrait",
  },
  {
    id: 3,
    title: "CloudBase 管理后台",
    category: "SaaS 平台",
    description: "企业级云管平台的数据可视化方案",
    color: "bg-[#e8e4dd]",
    image: "https://readdy.ai/api/search-image?query=Enterprise%20dashboard%20design%20with%20data%20visualization%20charts%2C%20clean%20modern%20admin%20panel%20interface%2C%20warm%20gray%20and%20cream%20tones%2C%20minimalist%20UI%2C%20professional%20software%20design%20showcase&width=600&height=800&seq=project-03&orientation=portrait",
  },
  {
    id: 4,
    title: "Artisan 手工艺平台",
    category: "电商平台",
    description: "连接手工艺人与消费者的全球市集",
    color: "bg-[#f0e0cc]",
    image: "https://readdy.ai/api/search-image?Query=Artisan%20marketplace%20website%20design%20with%20handcrafted%20products%2C%20warm%20terracotta%20and%20cream%20tones%2C%20elegant%20minimalist%20layout%2C%20product%20grid%20display%2C%20modern%20ecommerce%20interface%20showcase&width=600&height=800&seq=project-04&orientation=portrait",
  },
];

export const stats = [
  { label: "服务客户", value: "200+", suffix: "家" },
  { label: "完成项目", value: "500+", suffix: "个" },
  { label: "技术专家", value: "80+", suffix: "人" },
  { label: "客户满意度", value: "98", suffix: "%" },
];

export const teamMembers = [
  {
    name: "张明远",
    role: "创始人 & CEO",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20business%20portrait%20of%20Asian%20man%20in%20his%2040s%2C%20warm%20studio%20lighting%2C%20confident%20expression%2C%20cream%20background%2C%20modern%20corporate%20headshot%2C%20clean%20minimalist%20style&width=200&height=200&seq=team-01&orientation=squarish",
  },
  {
    name: "陈思涵",
    role: "CTO 技术总监",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%20in%20tech%20industry%2C%20warm%20lighting%2C%20friendly%20smile%2C%20cream%20studio%20background%2C%20modern%20corporate%20headshot%2C%20clean%20minimalist%20aesthetic&width=200&height=200&seq=team-02&orientation=squarish",
  },
  {
    name: "李俊峰",
    role: "设计总监",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20creative%20director%2C%20warm%20studio%20lighting%2C%20artistic%20vibe%2C%20cream%20background%2C%20modern%20headshot%2C%20clean%20minimalist%20style%20photography&width=200&height=200&seq=team-03&orientation=squarish",
  },
  {
    name: "王雅文",
    role: "运营副总裁",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%20business%20executive%2C%20warm%20studio%20lighting%2C%20confident%20look%2C%20cream%20background%2C%20modern%20corporate%20headshot%2C%20clean%20minimalist%20photography&width=200&height=200&seq=team-04&orientation=squarish",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "周志强",
    role: "CEO · 创新科技有限公司",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20businessman%2C%20warm%20lighting%2C%20friendly%20expression%2C%20cream%20background%2C%20modern%20corporate%20headshot%2C%20clean%20style&width=120&height=120&seq=testimonial-01&orientation=squarish",
    content: "Tianyi 团队不仅技术过硬，更难得的是他们对业务的理解深度。从需求分析到项目交付，每一步都超出预期。",
    rating: 5,
  },
  {
    id: 2,
    name: "林晓薇",
    role: "产品总监 · 绿叶子品牌",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%20product%20manager%2C%20warm%20studio%20lighting%2C%20confident%20smile%2C%20cream%20background%2C%20modern%20headshot%20photography&width=120&height=120&seq=testimonial-02&orientation=squarish",
    content: "与 Tianyi 合作两年，他们已经成为我们最信赖的技术伙伴。网站改版后，转化率提升了40%。",
    rating: 5,
  },
  {
    id: 3,
    name: "黄志豪",
    role: "创始人 · FitMotion",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20startup%20founder%2C%20warm%20lighting%2C%20energetic%20expression%2C%20cream%20background%2C%20modern%20headshot%20style&width=120&height=120&seq=testimonial-03&orientation=squarish",
    content: "从零到一的完整开发体验！Tianyi 的 App 开发团队帮我们在三个月内上线了 MVP，快速验证了市场。",
    rating: 5,
  },
  {
    id: 4,
    name: "赵雪琳",
    role: "CTO · CloudBase",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%20tech%20leader%2C%20warm%20lighting%2C%20professional%20look%2C%20cream%20background%2C%20modern%20corporate%20headshot&width=120&height=120&seq=testimonial-04&orientation=squarish",
    content: "云平台架构设计非常专业，扩展性和稳定性都很好。运维成本比之前降低了60%，团队非常满意。",
    rating: 5,
  },
  {
    id: 5,
    name: "刘建国",
    role: "技术经理 · Artisan 平台",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20man%20tech%20manager%2C%20warm%20lighting%2C%20friendly%20smile%2C%20cream%20background%2C%20modern%20corporate%20headshot&width=120&height=120&seq=testimonial-05&orientation=squarish",
    content: "Tianyi 的安全审计帮我们发现并修复了多个关键漏洞，服务专业且响应迅速。强烈推荐！",
    rating: 5,
  },
  {
    id: 6,
    name: "孙美琪",
    role: "市场总监 · GreenLife",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Asian%20woman%20marketing%20director%2C%20warm%20lighting%2C%20bright%20smile%2C%20cream%20background%2C%20modern%20headshot%20photography&width=120&height=120&seq=testimonial-06&orientation=squarish",
    content: "官网设计超出预期，品牌调性完美呈现。上线后客户询盘量翻倍，这对我们来说太重要了。",
    rating: 5,
  },
];